import React from 'react';

import {
  FilterButton,
  List,
  TopToolbar,
} from 'react-admin';

import {
  Box,
  Card,
} from '@mui/material';

import PrefillButton from '../../../utils/PrefillButton';
import Pagination from '../../../../layout/Pagination';

import { entityListMap } from '../../../../../constants/entityFeatures';
import entityTypes from '../../../../../constants/entityTypes';
import { prefillGoodsGetter } from './forms';
import { CarFilters } from '../../../../car/CarList';

const LIST_FILTERS = {
  [entityTypes.CAR]: CarFilters,
} as const;

const Goods = ({
  type,
  handleOpenChange,
}: {
  type: typeof entityTypes.CAR;
  handleOpenChange: () => void;
}) => {
  const EntityListBody = entityListMap[type];
  if (!EntityListBody) return null;

  return (
    <List
      perPage={10}
      filters={LIST_FILTERS[type]}
      pagination={<Pagination disableEmptyText />}
      resource="cars"
      actions={(
        <TopToolbar>
          <FilterButton />
        </TopToolbar>
      )}
      empty={false}
      component={Box}
      disableSyncWithLocation
      storeKey={false}
      sort={{ field: 'createdAt', order: 'DESC' }}
    >
      <Card variant="outlined">
        <EntityListBody>
          <PrefillButton
            handleOpenChange={handleOpenChange}
            prefillForm={prefillGoodsGetter(type)}
          />
        </EntityListBody>
      </Card>
    </List>
  );
};

export default Goods;
